/* eslint-disable */
export function range(end, start = 0) {
  return Array.from({ length: end - start + 1 }, (k, i) => i + start);
}
